export const loadingCss = 'animate__animated animate__flash animate__infinite	infinite'
